<!--
    Desarrollado por: Ing Wuilmer Garcia
    // Fecha:2023-12-12
    // Modificado por:
    // Fecha de ultima Modificacion:
    // Modificado por: 
    // Causa: 

-->

<template>
    <div>
        <!-- Formulario control cuenta x cobrar -->

        <v-form ref="formDatos" lazy-validation> 
                <v-card>
                   
                    <v-divider></v-divider>

                    <v-card-text>
                    <v-row class="pt-3">

                        <v-col cols="12" sm="4" md="3" class="py-0">
                            <v-text-field v-model="Datos.num_doc_cxc" ref="" label="Correlativo de CxC" dense
                                type="number" :rules="[validation.required]"
                                prepend-icon="fa-school" required>
                            </v-text-field>
                        </v-col>
                    </v-row>        

                </v-card-text>

                    <v-divider></v-divider>

                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn class="btn_style3" tile @click="$emit('close')">Cancelar</v-btn>
                        <v-btn class="btn_block_style2"  tile @click="saveItem">{{saveText}}</v-btn>
 

                    </v-card-actions>

                        <span v-if="test">
                            
                            <code>Datos:  {{Datos}} </code> <br>
                            <code>Session Empresa: {{JSON.stringify(session.id_empresa)}}</code>
                            <code>Session Empresa: {{JSON.stringify(session.nombre_sucursal)}}</code>
                            <code> Session sucursal: {{JSON.stringify(session.id_sucursal)}}</code>
                            <code>Session load_sucursal: {{JSON.stringify(session.load_sucursal)}}</code>
                            

                            <!--
                                <code>Datos Session {{JSON.stringify(session)}}</code>
                                <code>parametros :{{parametros}} </code> 

                            -->
                        </span>
                     </v-card>
               
           
        </v-form>
        <!-- fin control de cuenta x cobrar -->


    </div>
</template>

<script>

    import axios from "@/helpers/axios";
    import { validation } from "@/helpers/validator.js";
    import {mapActions, mapGetters, mapMutations } from 'vuex';

    export default {
        name:'ControlCompra',

        // props:['estadoComp' , 'parametros'],
        props:{
            parametros:{
                type:Object
            },
            estadoComp:{
                type:Boolean
            },
        },

        data(){
            return{
                
                session: sessionStorage,
                test:false,
                Datos: {},
                saveText : "Guardar Cambios",               
                listAlmacen:[],

                inhabilitarButton:false,

               
            }
        },
       
        mounted() {  
             this.loadMain()
        },

        //computadas
        computed: {
            validation() {
                return validation;
            },        

        },
        
        
        watch: {
            // cada vez que la pregunta cambie, esta función será ejecutada
            estadoComp() {
                if(this.estadoComp){
                    this.loadMain()                    
                }else{   
                    //this.parametros = {}
                    this.limpiarForm()
                 
                }
            }
        },
        

        methods: {
            ...mapMutations('mensajeSis', ['setEnviarMens']),
            

            async loadMain(){

                this.limpiarForm() 
                this.getQuery()
           
            },


            //-------mostrar registros------------
            async getQuery(){
                try{
                    console.log(`controlCompra getQuery`)
                    let params ={id_empresa: this.session.id_empresa }

                    if (!this.session.id_sucursal) {
                        this.setEnviarMens({tipo:"W", mensaje: `Error en selecionar sucursal`, tiempo:null})
                        return 
                    }

                    let response = await axios.get(`/sistema/configuracion/cxc/empresa/${this.session.id_empresa}/sucursal/${this.session.id_sucursal}`)
                    // this.listAlmacen    = response.data.Almacen
                    
                    if(response.data.CxCConfig){
                        this.Datos          = response.data.CxCConfig
                    }
                    
                }
                catch(e){
                    if (e.response) {
                        let resp = e.response.data
                        console.log(resp)
                        this.setEnviarMens({tipo:resp.messageT, mensaje: `${resp.message}`, tiempo:null})                        
                    }
                }
                
           },


           
            // Guarda CONTROL COMPRA
            async saveItem(){
                if (!this.$refs.formDatos.validate()) {
                    this.setEnviarMens({tipo:"W", mensaje: `Debe Ingresar todos los campos requeridos en el Formulario`, tiempo:null})
                    return 
                }

                if (!this.session.id_sucursal) {
                    this.setEnviarMens({tipo:"W", mensaje: `Error en selecionar sucursal`, tiempo:null})
                    return 
                }
                this.Datos.id_sucursal = this.session.id_sucursal

                try{    
                    let params = {cxc:this.Datos}
                    let res = await axios.put(`/sistema/configuracion/cxc/empresa/${this.session.id_empresa}`,params)
                    // this.$emit('reloadComp','empresa')
                    // this.$emit('close')
                    this.setEnviarMens({tipo:`${res.data.messageT}`, mensaje: `${res.data.message}`, tiempo:6000})
                    
                }   

                catch(e){
                    if (e.response) {
                        let resp = e.response.data
                        console.log(resp)
                        this.setEnviarMens({tipo:resp.messageT, mensaje: `${resp.message}`, tiempo:null})                        
                    }
                }            

            },
        
         
            limpiarForm(){

                this.Datos = {
                                id_usuario: this.session.id, id_empresa : this.session.id_empresa, id_sucursal: this.session.id_sucursal,
                                num_doc_cxc:''                                    
                }                
                
                this.resetValidation()
                
            },

            // Validar resetear campos al guardar
            resetValidation() {
                this.$refs.formDatos.resetValidation()
            },
         

        },
    }
</script>


<style scoped>
</style>